import { debounce, values } from 'lodash';
import { ref, toValue, watchEffect, onWatcherCleanup } from 'vue';

const CLUDO_CONFIG = (() => {
	let lookup = {
		customerId: import.meta.env.VITE_CLUDO_CUSTOMER_ID,
		engineId: import.meta.env.VITE_CLUDO_ENGINE_ID,
		apiHostName: import.meta.env.VITE_CLUDI_API_HOSTNAME,
		apiKey: import.meta.env.VITE_CLUDO_API_KEY
	};

	lookup.bearer_key = `Basic ` + btoa(`${lookup.customerId}:${lookup.apiKey}`);

	return lookup;
})();
const FETCH_DEBOUNCE_WAIT = 250;

let call = (endpoint, method = 'GET', params) => {
	const data = ref(null);
	const error = ref(null);
	const searching = ref(false);

	const updateAnalytics = (requestBody, response) => {
		try {
			let queryId = response.QueryId;

			if (!queryId) return;

			let jsonRequestBody = JSON.parse(requestBody);

			// console.log({ jsonRequestBody, response });

			let referralPageTitle =
				document.querySelector('meta[property="og:title"]').getAttribute('content') ??
				document.title;
			let bannerIds = (response.Banners ?? []).map((Banner) => Banner.Id).join(',');

			let data = {
				query: jsonRequestBody.query,
				queryId: queryId,
				totalResults: response.TotalDocument,
				pageNumber: 1,
				referralPageUrl: window.location.href,
				referralPageTitle: referralPageTitle,
				responseTime: response.ResponseTime,
				bannerIds: bannerIds
			};

			window.CludoSearch.trackQuery(
				data.query,
				data.queryId,
				data.totalResults,
				data.pageNumber,
				data.referralPageUrl,
				data.referralPageTitle,
				data.responseTime,
				data.bannerIds
			);
		} catch (error) {
			return;
		}
	};

	const debouncedEffect = debounce(async (body, signal) => {
		try {
			const response = await fetch(`${CLUDO_CONFIG.apiHostName}/${endpoint}`, {
				method: method,
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
					Authorization: CLUDO_CONFIG.bearer_key
				},
				body,
				signal
			});

			if (!response.ok) throw new Error('Request did not succeed');

			let json = await response.json();

			data.value = json;

			updateAnalytics(body, json);

			searching.value = false;
		} catch (e) {
			error.value = e;
			searching.value = false;
		}
	}, FETCH_DEBOUNCE_WAIT);

	watchEffect(() => {
		let paramsValue = toValue(params);

		if (!paramsValue?.query) return { data, error };

		let controller = new AbortController();

		// data.value = null;
		error.value = null;
		searching.value = true;

		let body = JSON.stringify(paramsValue);

		debouncedEffect(body, controller.signal);

		onWatcherCleanup(() => {
			controller.abort();
		});
	});

	return { data, error, searching };
};

export function search(params) {
	const endpoint = `${CLUDO_CONFIG.customerId}/${CLUDO_CONFIG.engineId}/search`;

	return call(endpoint, 'POST', params);
}

export function autocomplete(params) {
	const endpoint = `${CLUDO_CONFIG.customerId}/${CLUDO_CONFIG.engineId}/autocomplete`;

	return call(endpoint, 'POST', params);
}

export async function quicklinks() {
	try {
		const response = await fetch(`/ajax/cludo-api/quicklinks`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json'
			}
		});

		if (!response.ok) throw new Error('Request did not succeed');

		let json = await response.json();

		return json;
	} catch (error) {
		return [];
	}
}

export default {
	search,
	autocomplete,
	quicklinks
};
